import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=7613ebf0&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=ts"
export * from "./EventList.vue?vue&type=script&lang=ts"
import style0 from "./EventList.vue?vue&type=style&index=0&id=7613ebf0&prod&lang=css"
import style1 from "./EventList.vue?vue&type=style&index=1&id=7613ebf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7613ebf0",
  null
  
)

export default component.exports